import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { map, filter, indexOf } from 'lodash';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import ProgressBar from '../../../../components/progress-bar';
import piPermissions from '../../../../components/pi-permission';
import UserTable from '../../../Setup/components/UserTable/UserTable';
import NumberDisplay from '../../../../components/number-display';

// Import Actions
import { fetchAllAdminUsers } from '../../AdminActions';

// Import Selectors
import { getAdminUsers } from '../../AdminReducer';
import { getUser } from '../../../Auth/AuthReducer';

class OrganizationAdminPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIds: [],
    };
    this.syncUsers = this.syncUsers.bind(this);
    this.handleToggleSelect = this.handleToggleSelect.bind(this);
    this.handleToggleAll = this.handleToggleAll.bind(this);
  }

  syncUsers(params) {
    return this.props.dispatch(fetchAllAdminUsers(params));
  }

  handleToggleSelect(users) {
    this.setState({ selectedIds: map(users, '_id') });
  }
  handleToggleAll() {
    const { selectedIds } = this.state;
    const { users: { items } } = this.props;
    if (selectedIds.length === items.length) {
      this.setState({ selectedIds: [] });
    } else {
      this.setState({ selectedIds: map(items, '_id') });
    }
  }

  renderMailLink() {
    const { selectedIds } = this.state;
    const { users: { items } } = this.props;
    const users = filter(items, data => indexOf(selectedIds, data._id) >= 0);
    const emails = map(users, 'email');
    const hasSelected = emails.length > 0;
    const href = `mailto:?bcc=${emails.join(',')}`;
    return (
      <span>
        {hasSelected && <a href={href} className="btn btn-primary">
          <Fa name="envelope" /> Send Email (<NumberDisplay value={selectedIds.length} precision={0} />)
        </a>}
        {!hasSelected && <a className="btn btn-primary disabled">
          <Fa name="envelope" /> Send Email
        </a>}
        &nbsp;&nbsp;&nbsp;
      </span>
    );
  }

  render() {
    const { selectedIds } = this.state;
    return (
      <div>
        <Helmet title="Manage Admin Users" />
        <p />
        <div className="container">
          <UserTable
            selectedIds={selectedIds}
            showActionColumn={false}
            toggleSelect={this.handleToggleSelect}
            showOrganizationRoleColumn={false}
            topControl={this.renderMailLink()}
            selectable
            fetchAction={this.syncUsers}
          />
        </div>
      </div>
    );
  }
}

// SetupPage.need = [() => { return fetchStages(); }];

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loginUser: getUser(state),
    users: getAdminUsers(state),
  };
}

OrganizationAdminPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  users: PropTypes.shape({
    items: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
  }).isRequired,
  loginUser: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  children: PropTypes.element,
};

OrganizationAdminPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(piPermissions(OrganizationAdminPage, 'superadmin', 'admin'));
